const awsmobile =  {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:470a94ce-14ad-48f7-becd-c690ed067140",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_GevyuFbPg",
    "aws_user_pools_web_client_id": "370sq3t1kha745uuvs74fi7h9q"
};


export default awsmobile;